
import {mapActions} from "vuex";
import DocumentContractProfileTab
  from "@/components/organisms/ContractProfileTemplatePanel/DocumentContractProfileTab.vue";
import GenericContractProfileTab
  from "@/components/organisms/ContractProfileTemplatePanel/GenericContractProfileTab.vue";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {defineComponent, PropType} from "vue";
import {ContractProfile} from "@/store/modules/hcs/contractProfile/model";
import {ContractProfileTemplate} from "@/store/modules/hcs/contractProfileTemplate/model";
import ContractProfileTemplateForm from "@/components/organisms/ContractProfileTemplateForm.vue";

export default defineComponent({
  name: "ContractProfileTemplatePanel",
  components: {ContractProfileTemplateForm, TextFieldLike, FormPageTemplate, DocumentContractProfileTab, GenericContractProfileTab},
  props: {
    contractProfileTemplateId: {
      type: [String, null] as PropType<null | string>,
      required: false,
      default: null,
    },
    tradeContractId: {
      type: [String, null] as PropType<null | string>,
      required: false,
      default: null,
    },
    tradeContractFormatId: {
      type: [String, null] as PropType<null | string>,
      required: false,
      default: null,
    },
    showApplyButton: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "dirty", "save", "change:contract-profiles"
  ],
  data() {
    return {
      contractProfileTemplate: null as null | ContractProfileTemplate,
      contractProfiles: [] as ContractProfile[],
    };
  },
  methods: {
    ...mapActions({
      loadContractProfiles: 'hcs/contractProfile/findList',
      loadContractProfileTemplate: 'hcs/contractProfileTemplate/get',
      updateContractProfileTemplate: 'hcs/contractProfileTemplate/update',
    }),
    async load() {
      if(this.contractProfileTemplateId) {
        this.contractProfileTemplate = await this.loadContractProfileTemplate({id: this.contractProfileTemplateId});
        this.contractProfiles = await this.loadContractProfiles({contractProfileTemplateIdEq: this.contractProfileTemplateId});
      } else if(this.tradeContractId) {
        this.contractProfiles = await this.loadContractProfiles({tradeContractIdEq: this.tradeContractId});
      } else if(this.tradeContractFormatId) {
        this.contractProfiles = await this.loadContractProfiles({tradeContractFormatIdEq: this.tradeContractId});
      } else {
        throw new Error("contractProfileTemplateId か tradeContractId か tradeContractFormatId のいずれかが必要です")
      }
      this.contractProfiles = this.contractProfiles.slice();
    },
    async save() {
      if(this.contractProfileTemplateId) {
        await this.updateContractProfileTemplate(this.contractProfileTemplate);
      }
    }
  },
});
